export enum SIZES {
    NONE = 'SIZE.NONE',
    L = 'SIZE.L',
    XL = 'SIZE.XL',
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const sizeValues = [...Object.values(SIZES)] as const;
export type SizeType = typeof sizeValues[number];

export const SIZES_CLASSES: {[key in SIZES]: string | null} = {
    [SIZES.NONE]: null,
    [SIZES.L]: 'icon-button_size-l',
    [SIZES.XL]: 'icon-button_size-xl',
};
